import React, { FC } from 'react';
import { SkillTabType } from '@components/profile/profileOverlay/overlays/skill/index';

import classnames from 'classnames/bind';
import styles from './skill.module.scss';
const cx = classnames.bind(styles);

interface ISkillTab {
  selectedTabType: SkillTabType;
  setSelectedTabType: (selectedTab: SkillTabType) => void;
}

const SkillTab: FC<ISkillTab> = ({ selectedTabType, setSelectedTabType }) => {
  const isOn = (tabType: SkillTabType) => tabType === selectedTabType;

  return (
    <div className={cx('tabArea')}>
      <a
        // [D] 선택된 탭은 'on' 클래스 추가
        className={cx('tab', { on: isOn('LICENSE') })}
        role="button"
        onClick={() => setSelectedTabType('LICENSE')}
      >
        자격증
      </a>
      <a
        className={cx('tab', { on: isOn('EXAMINATION') })}
        role="button"
        onClick={() => setSelectedTabType('EXAMINATION')}
      >
        공인 어학시험
      </a>
      <a
        className={cx('tab', { on: isOn('SKILL_KEYWORD') })}
        role="button"
        onClick={() => setSelectedTabType('SKILL_KEYWORD')}
      >
        기술 키워드
      </a>
    </div>
  );
};

export default SkillTab;
